module.exports = __webpack_public_path__ + "static/media/sky-music.134dd2e2.png";